var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 61 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2714 40.792C34.808 40.792 39.0009 39.5135 42.3552 37.3415C44.9534 35.6781 48.3352 35.953 50.6172 38.0288C56.9547 43.7752 60.5564 51.9272 60.5427 60.4917V64.1622C60.5427 67.9564 57.4633 71.022 53.6691 71.022H6.87374C3.07952 71.022 0.000156266 67.9564 0.000156266 64.1622V60.4917C-0.0273381 51.941 3.57442 43.7752 9.91186 38.0426C12.1939 35.9668 15.5894 35.6918 18.1739 37.3552C21.542 39.5135 25.7211 40.792 30.2714 40.792Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2707 34.6747C39.6701 34.6747 47.2897 27.055 47.2897 17.6557C47.2897 8.25638 39.6701 0.636719 30.2707 0.636719C20.8714 0.636719 13.2517 8.25638 13.2517 17.6557C13.2517 27.055 20.8714 34.6747 30.2707 34.6747Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.9293d93810cea7cdcbd81ff8aadf2bdd.svg";
export { ForwardRef as ReactComponent };